const Shimmer=()=>{
    return(
        <div className="p-2 m-2 w-72 bg-gray-200 rounded-lg shadow-lg h-[350px]">

        </div>
    )
}
export default Shimmer